import { Event } from "../EventTypes";

export function findUpcomingEvents(): Promise<Event[]> {
    return fetch('/api/events', {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    })
        .then(res => {
            if (res.ok) {
                return res.json();
            } else {
                Promise.reject(res.status);
            }
        });
}

export function findEventByReference(id?: string): Promise<Event> {
    return fetch(`/api/events/${id}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    })
        .then(res => {
            if (res.ok) {
                return res.json();
            } else {
                return null;
            }
        });
}